export default __webpack_public_path__ + "static/media/objects.d5f32382.svg";